import {FC, ReactNode, useState} from "react";
import {css, cx} from "@pandacss/css";
import {font} from "../style/typography.tsx";
import {InfoCircleErrorIcon} from "./Icon";
import * as React from "react";

interface Props {
    name?: string;
    type?: "text" | "tel" | "email" | "password";
    value: string;
    onChange?: (value: string) => void;
    error?: boolean;
    disabled?: boolean;
    placeholder?: string;
    leftContent?: ReactNode;
    rightContent?: ReactNode;
    onSubmit?: () => void
}

const outerClass = css({
    height: '36px',
    padding: '0 12px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    border: '1px solid',
    borderColor: 'neutral.280',
    backgroundColor: 'neutral.700',
    borderRadius: '8px',
    color: 'neutral.100',
})

const focusClass = css({
    border: '1px solid',
    borderColor: 'primary.400',
    outline: '1px solid',
    outlineColor: 'primary.400',
})

const errorClass = css({
    border: '1px solid',
    borderColor: 'error.500',
    outline: '1px solid',
    outlineColor: 'error.500',
});

const disabledClass = css({
    backgroundColor: 'neutral.350',
    borderColor: 'neutral.280',
    color: 'neutral.250',
    cursor: 'not-allowed',

})

const inputClass = css({
    height: '100%',
    flex: '1',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
});

const Input: FC<Props> = ({name, type, value, onChange, error, disabled, placeholder, leftContent, rightContent, onSubmit}) => {
    const [focused, setFocused] = useState(false);

    const onPressEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (!onSubmit) {
            return;
        }

        if (event.key === 'Enter') {
            onSubmit();
        }
    }

    return <div className={cx(outerClass, font('body', '1', 'regular'), focused && focusClass, error && errorClass, disabled && disabledClass)}>
        {leftContent}
        <input
            name={name}
            type={type || "text"}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            className={inputClass}
            disabled={disabled}
            placeholder={placeholder}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onKeyDown={onPressEnter}
        />
        {error && <InfoCircleErrorIcon size={16} />}
        {rightContent}
    </div>
}

export default Input;

